var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPontesLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 924,
    height: 235,
    viewBox: "0 0 924 235",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m834.66575 164.81557v-16.215h86.20263v16.215z",
    fill: "#ff6d2d"
  }), /*#__PURE__*/React.createElement("text", {
    x: 2.0810812,
    y: 135.27028,
    fontSize: 146.666,
    fontFamily: "sans-serif",
    fontWeight: "bold",
    fill: "#000"
  }, "\n            appspontes\n        "))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 924,
    height: 235
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPontesLogo);
export default __webpack_public_path__ + "static/media/pontes_logo.69050fc331815836e3d9926c6701f87d.svg";
export { ForwardRef as ReactComponent };